import React, { createContext, useContext, useEffect, useState } from 'react';
import { User, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/config';

interface AuthContextType {
  user: User | null;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType>({ user: null, loading: true });

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser: User | null) => {
      // A newly provisioned owner must not inherit the previous account's tenant headers.
      const previousUid = localStorage.getItem('spark_context_user_id');
      if (!firebaseUser || previousUid !== firebaseUser.uid) {
        localStorage.removeItem('spark_org_id');
        localStorage.removeItem('spark_workspace_id');
      }
      if (firebaseUser) localStorage.setItem('spark_context_user_id', firebaseUser.uid);
      else localStorage.removeItem('spark_context_user_id');
      setUser(firebaseUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
